import React, { FC } from "react";

import { Breadcrumbs as CoreBreadcrumbs, Crumb } from "components";

import { EXTERNAL_VENDORS_PAGE } from "constants/routes.constants";

const Breadcrumbs: FC = () => {
  return (
    <CoreBreadcrumbs>
      <Crumb appearance="text" name={EXTERNAL_VENDORS_PAGE.name} />
    </CoreBreadcrumbs>
  );
};

export default Breadcrumbs;
